import { createContext, useContext, useState, useCallback, type ReactNode } from "react";
import type { Database } from "@/types/database.types";

type TaskWithDetailsRow = Database["public"]["Views"]["tasks_with_details"]["Row"];

interface TaskDialogContextType {
  openTaskDialog: (task: TaskWithDetailsRow) => void;
  taskToOpen: TaskWithDetailsRow | null;
  clearTaskToOpen: () => void;
}

const TaskDialogContext = createContext<TaskDialogContextType | undefined>(undefined);

export function TaskDialogProvider({ children }: { children: ReactNode }) {
  const [taskToOpen, setTaskToOpen] = useState<TaskWithDetailsRow | null>(null);

  const openTaskDialog = useCallback((task: TaskWithDetailsRow) => {
    setTaskToOpen(task);
  }, []);

  const clearTaskToOpen = useCallback(() => {
    setTaskToOpen(null);
  }, []);

  return (
    <TaskDialogContext.Provider value={{ openTaskDialog, taskToOpen, clearTaskToOpen }}>
      {children}
    </TaskDialogContext.Provider>
  );
}

export function useTaskDialog() {
  const context = useContext(TaskDialogContext);
  if (context === undefined) {
    throw new Error("useTaskDialog must be used within a TaskDialogProvider");
  }
  return context;
}